<script>
    export let title;
    export let style = '';
    export let click_action = null;

    import InfoIcon from './InfoIcon.svelte';
</script>

<div class="selection-title__title" {style}>
    {title}
    {#if click_action}
        <InfoIcon
            {click_action}
        />
    {/if}
</div>

<style>
    .selection-title__title {
        color: #777;
        font-weight: 400;
        font-size: 10px;
        padding-bottom: 4px;
        text-transform: uppercase;
    }
</style>